Aedu.AnalyticsDashboard = Aedu.AnalyticsDashboard || {};
Aedu.AnalyticsDashboard.Subscribing = Aedu.AnalyticsDashboard.Subscribing || {};
(function() {
  if (window.Analytics == null) {
    window.Analytics = {};
  }

  window.Analytics.Utilities = {
    parseUri: function(str) {
      var i, m, o, uri;
      o = {
        strictMode: false,
        key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
        q: {
          name: "queryKey",
          parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
          strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
          loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
      };
      m = o.parser[o.strictMode ? "strict" : "loose"].exec(str);
      uri = {};
      i = 14;
      while (i--) {
        uri[o.key[i]] = m[i] || "";
      }
      uri[o.q.name] = {};
      uri[o.key[12]].replace(o.q.parser, function($0, $1, $2) {
        if ($1) {
          return uri[o.q.name][$1] = $2;
        }
      });
      return uri;
    },
    domainNameFromUrl: function(originalUrl) {
      var domainName, parsedUri;
      parsedUri = window.Analytics.Utilities.parseUri(originalUrl);
      return domainName = parsedUri.host.replace('www.', '');
    },
    transformToDayCounts: function(itemsGroupedByDate) {
      var finishMoment, itemsByDay, ref, startMoment, thisDayCount, thisDayString;
      itemsByDay = [];
      startMoment = moment(Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.start);
      finishMoment = moment(Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates.finish);
      while (startMoment.isBefore(finishMoment.endOf('day'))) {
        thisDayString = startMoment.format('YYYY-MM-DD');
        thisDayCount = ((ref = itemsGroupedByDate[thisDayString]) != null ? ref.length : void 0) || 0;
        itemsByDay.push(thisDayCount);
        startMoment.add(1, 'day');
      }
      return itemsByDay;
    },
    dateParams: function(displayedDates) {
      return _.chain(displayedDates).pick('start', 'finish').map(function(date, key) {
        return [key, moment(date).format()];
      }).object().value();
    },
    isCurrentThirtyDays: function(displayedDates) {
      return moment(new Date(displayedDates.finish)).isSame(moment(), 'day') && displayedDates.dayCount === 30;
    }
  };

}).call(this);
Aedu.Payments = Aedu.Payments || {};
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  Aedu.Payments.AddBillingDetails = createReactClass({
    FIELD_LABELS: {
      name: 'Name',
      address_1: 'Address 1 / Title',
      address_2: 'Address 2',
      address_3: 'Address 3',
      city: 'City / Location',
      zip_code: 'Zip Code / Providence',
      country: 'Country',
      tax_id: 'Tax ID'
    },

    ALLOWED_FIELDS: ['name', 'address_1', 'address_2', 'address_3', 'city', 'zip_code', 'country', 'tax_id'],

    getInitialState: function () {
      return {
        name: '',
        address_1: '',
        address_2: '',
        address_3: '',
        city: '',
        zip_code: '',
        country: '',
        tax_id: '',
        isLoading: true
      };
    },

    onChange: function (e) {
      var key = e.target.name;
      var value = e.target.value;
      this.setState(_defineProperty({}, key, value));
    },
    componentDidMount: function () {
      var _this = this;

      return $.ajax({
        url: $r.api_v0_premium_user_invoice_billing_details_path({
          subdomain_param: 'api'
        }),
        type: 'GET',
        dataType: 'json',
        success: function (data) {
          _this.setState(_extends({}, data, { isLoading: false }));
        },
        error: function (_err) {
          _this.setState({ error: true, isLoading: false });
        }
      });
    },

    closeModal: function () {
      this.props.closeModal();
    },

    render: function () {
      var _this2 = this;

      if (this.state.isLoading) {
        return React.createElement(
          'div',
          {
            className: 'u-taCenter u-pt4x u-pb8x',
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingTop: '30px',
              paddingBottom: '30px'
            }
          },
          React.createElement('i', { className: 'fa fa-spin fa-spinner u-fs36 u-tcGrayDark' })
        );
      } else if (this.state.error) {
        return React.createElement(
          'div',
          { className: 'u-taCenter u-pt4x u-pb8x' },
          React.createElement(
            'p',
            { className: 'u-tcRed' },
            'An error occurred. Please try again later.'
          )
        );
      } else {
        return React.createElement(
          'div',
          { className: 'DesignSystem' },
          React.createElement(
            'div',
            { className: 'u-p8x' },
            React.createElement(
              'h1',
              { className: 'u-taCenter u-fs20 u-fw400 u-m0x' },
              'Add Billing Details'
            ),
            React.createElement(
              'p',
              {
                className: 'u-fontStyleItalic u-tcGrayDark u-mb0x u-mt2x',
                style: { textAlign: 'center' }
              },
              'This information will be included in your renewal invoice and receipts.'
            ),
            React.createElement(
              'form',
              null,
              Object.keys(this.state).map(function (field, index) {
                if (_this2.ALLOWED_FIELDS.includes(field)) {
                  var placeholderText = _this2.FIELD_LABELS[field];
                  var valueText = _this2.state[field];
                  return React.createElement(
                    'div',
                    { key: index },
                    React.createElement(
                      'label',
                      { htmlFor: field },
                      _this2.FIELD_LABELS[field]
                    ),
                    ' ',
                    React.createElement('br', null),
                    React.createElement('input', {
                      type: 'text',
                      placeholder: placeholderText,
                      value: valueText,
                      name: field,
                      id: field,
                      className: 'TextInput--lg u-mb4x',
                      style: { width: '100%' },
                      onChange: _this2.onChange
                    })
                  );
                }
              }),
              React.createElement(
                'button',
                {
                  className: 'Button--blue Button--md',
                  'aria-label': 'Submit',
                  style: { width: '100%' },
                  onClick: this.handleSubmit
                },
                'Submit'
              )
            )
          )
        );
      }
    },
    handleSubmit: function (e) {
      e.preventDefault();
      var close = this.closeModal.bind(this);
      return $.ajax({
        url: $r.api_v0_premium_user_invoice_billing_details_path({
          subdomain_param: 'api'
        }),
        type: 'POST',
        data: {
          user_invoice_billing_details: {
            name: this.state.name,
            address_1: this.state.address_1,
            address_2: this.state.address_2,
            address_3: this.state.address_3,
            city: this.state.city,
            zip_code: this.state.zip_code,
            country: this.state.country,
            tax_id: this.state.tax_id
          }
        }
      }).success(function () {
        Components.Utils.showToast(Components.Toasts.BasicToast, {
          text: 'Billing details successfully updated'
        });

        setTimeout(function () {
          close();
        }, 2000);
      }).fail(function () {
        setTimeout(function () {
          Components.Utils.showToast(Components.Toasts.BasicToast, {
            text: 'Something went wrong! Please try again or contact support.'
          }, { color: 'Red' });
        }, 5000);
      });
    }
  });
})();
(function () {

  Aedu.Payments.SavedPaypal = createReactClass({

    getInitialState: function () {
      return {
        customer: null
      };
    },

    componentDidMount: function () {
      this.fetchCustomer();
    },

    fetchCustomer: function () {
      $.ajax({
        url: $r.api_v0_braintree_payment_method_path({
          subdomain_param: 'api'
        }),
        type: 'GET'
      }).done((function (response) {
        this.setState({ customer: response });
      }).bind(this));
    },

    render: function () {
      if (this.state.customer) {
        return this.renderPaypal();
      } else {
        return this.renderSpinner();
      }
    },

    renderSpinner: function () {
      return React.createElement(
        'div',
        null,
        React.createElement('i', { className: 'fa fa-spinner fa-spin' }),
        React.createElement(
          'i',
          { className: 'u-ml1x' },
          ' Loading PayPal information... '
        )
      );
    },

    renderPaypal: function () {
      return React.createElement(
        'div',
        null,
        React.createElement('i', { className: 'fa fa-cc-paypal u-fs24 u-verticalAlignMiddle u-mr1x ' }),
        React.createElement(
          'span',
          null,
          this.state.customer.email
        ),
        '  ',
        React.createElement(
          'a',
          { className: 'u-clickable', href: 'https://www.paypal.com/signin', target: '_blank' },
          'Update PayPal Preferences'
        )
      );
    }
  });
})();
(function () {
  Aedu.Payments.SavedStripePaymentMethod = createReactClass({
    getInitialState: function () {
      return {
        customer: null
      };
    },

    componentDidMount: function () {
      this.fetchCustomer();
    },

    fetchCustomer: function () {
      $.ajax({
        url: $r.api_v0_stripe_customer_path({
          subdomain_param: 'api'
        }),
        type: 'GET'
      }).done((function (response) {
        this.setState({ customer: response });
      }).bind(this));
    },

    render: function () {
      if (this.state.customer) {
        return this.renderPaymentMethods();
      } else {
        return this.renderSpinner();
      }
    },

    // eslint-disable-next-line react/display-name
    renderSpinner: function () {
      return React.createElement(
        'div',
        null,
        React.createElement('i', { className: 'fa fa-spinner fa-spin' }),
        React.createElement(
          'i',
          { className: 'u-ml1x' },
          ' Loading payment information... '
        )
      );
    },

    // eslint-disable-next-line react/display-name
    renderPaymentMethods: function () {
      if (!this.state.customer.default_payment_method) {
        // Comped admins will not have a card on file
        // (Do we want to allow changes despite this?)
        return React.createElement(
          'div',
          null,
          'You do not have a payment method on file.'
        );
      }

      var rendered_default_pm = React.createElement(
        'div',
        null,
        this.renderPaymentMethod(this.state.customer.default_payment_method.display),
        '  ',
        React.createElement(
          'a',
          { className: 'u-clickable', onClick: this.showUpdateModal('default') },
          'Change'
        )
      );

      if (!this.state.customer.allow_secondary_payment_methods) {
        return rendered_default_pm;
      }

      var rendered_secondary_pm = undefined;
      if (!this.state.customer.secondary_payment_method) {
        rendered_secondary_pm = React.createElement(
          'div',
          null,
          React.createElement(
            'a',
            {
              className: 'u-clickable',
              onClick: this.showUpdateModal('secondary')
            },
            'Add payment method'
          )
        );
      } else {
        rendered_secondary_pm = React.createElement(
          'div',
          null,
          this.renderPaymentMethod(this.state.customer.secondary_payment_method.display),
          '  ',
          React.createElement(
            'a',
            {
              className: 'u-clickable',
              onClick: this.showUpdateModal('secondary')
            },
            'Change'
          )
        );
      }

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'u-fs16 u-fw700 u-mt5x u-mb2x' },
          'Default payment method'
        ),
        rendered_default_pm,
        React.createElement(
          'div',
          { className: 'u-fs16 u-fw700 u-mt5x u-mb2x' },
          'Secondary payment method'
        ),
        React.createElement(
          'div',
          { className: 'u-mt2x u-mb2x' },
          'For renewals, if your default payment method fails, we will attempt to charge your secondary payment method'
        ),
        rendered_secondary_pm
      );
    },

    // eslint-disable-next-line react/display-name
    renderPaymentMethod: function (pm_display) {
      if (pm_display.type === 'card') {
        return React.createElement(
          'span',
          null,
          this.renderCardLogo(pm_display.brand),
          ' Ending in ',
          React.createElement(
            'span',
            { className: 'u-fw700' },
            pm_display.last4
          ),
          ' - Expires ',
          React.createElement(
            'span',
            { className: 'u-fontStyleItalic' },
            pm_display.exp_month,
            '/',
            pm_display.exp_year
          )
        );
      } else if (pm_display.type === 'us_bank_account') {
        return React.createElement(
          'span',
          null,
          React.createElement(
            'span',
            { className: 'u-fw700' },
            pm_display.name,
            ' ···· ',
            pm_display.last4
          )
        );
      } else if (pm_display.type === 'sepa_debit') {
        return React.createElement(
          'span',
          null,
          React.createElement(
            'span',
            { className: 'u-fw700' },
            'SEPA Direct Debit ···· ',
            pm_display.last4
          )
        );
      } else {
        return React.createElement(
          'span',
          null,
          React.createElement(
            'span',
            { className: 'u-fw700' },
            'You are using an unknown payment method.'
          )
        );
      }
    },

    // eslint-disable-next-line react/display-name
    renderCardLogo: function (payment_method_brand) {
      if (this.cardLogoClass(payment_method_brand)) {
        var classes = classNames('fa u-fs24 u-verticalAlignMiddle u-mr1x', this.cardLogoClass(payment_method_brand));

        return React.createElement('i', { className: classes });
      } else {
        return payment_method_brand;
      }
    },

    cardLogoClass: function (payment_method_brand) {
      return ({
        visa: 'fa-cc-visa',
        amex: 'fa-cc-amex',
        mastercard: 'fa-cc-mastercard',
        discover: 'fa-cc-discover'
      })[payment_method_brand];
    },

    showUpdateModal: function (paymentSaveDestination) {
      return (function () {
        Components.Utils.showModal(Aedu.Payments.UpdateStripePaymentMethod, {
          stripeKey: this.props.stripeKey,
          currency: this.props.currency,
          defaultPaymentSuccessUrl: this.props.defaultPaymentSuccessUrl,
          secondaryPaymentSuccessUrl: this.props.secondaryPaymentSuccessUrl,
          paymentSaveDestination: paymentSaveDestination,
          paymentMethodConfiguration: this.props.paymentMethodConfiguration,
          paymentIntentClientSecret: this.props.paymentIntentClientSecret,
          paymentIntentAmount: this.props.paymentIntentAmount
        });
      }).bind(this);
    }
  });
})();
/* eslint-disable react/display-name */
(function () {
  Aedu.Payments.UpdateStripePaymentMethod = createReactClass({
    buttonText: function (paymentIntentAmount, saveDestination) {
      if (paymentIntentAmount) {
        return 'Pay ' + paymentIntentAmount;
      } else {
        if (saveDestination === 'secondary') {
          return 'Add Backup Payment Method';
        } else {
          return 'Update Payment Method';
        }
      }
    },

    disclaimerText: function (paymentIntentAmount, saveDestination) {
      var buttonText = this.buttonText(paymentIntentAmount, saveDestination);
      // pay existing past due payment
      if (paymentIntentAmount) {
        if (saveDestination === 'secondary') {
          return 'By clicking "' + buttonText + '" you authorize Academia.edu to process your\n            past due payment now using this payment method.  This payment method will be\n            used automatically if your primary payment method fails for any future\n            transactions.';
        } else {
          return 'By clicking "' + buttonText + '" you authorize Academia.edu to process your\n            past due payment now using this payment method.  This payment method will be\n            made your default for all future transactions.';
        }
      } else {
        if (saveDestination === 'secondary') {
          return 'You will not be charged until the end of your current billing cycle.\n            By clicking "' + buttonText + '" you agree that this payment method will be used\n            automatically if your primary payment method fails.';
        } else {
          return 'You will not be charged until the end of your current billing cycle.\n            By clicking "' + buttonText + '" you agree to set this payment method as your\n            default for all future transactions.';
        }
      }
    },

    render: function () {
      return React.createElement(
        'div',
        { className: 'DesignSystem' },
        React.createElement(
          'div',
          { className: 'u-p8x' },
          React.createElement(
            'h1',
            { className: 'u-taCenter u-fs20 u-fw400 u-m0x u-mb2x' },
            'Update Your',
            ' ',
            this.props.paymentSaveDestination === 'secondary' ? 'Secondary ' : '',
            'Payment Method'
          ),
          React.createElement(Aedu.Payments.StripePaymentMethodForm, {
            onError: this.handleError,
            submitButtonLabel: this.buttonText(this.props.paymentIntentAmount, this.props.paymentSaveDestination),
            submitButtonClasses: 'Button--green ButtonHoverMild',
            stripeKey: this.props.stripeKey,
            currency: this.props.currency.toLowerCase(),
            paymentMethodConfiguration: this.props.paymentMethodConfiguration,
            paymentIntentClientSecret: this.props.paymentIntentClientSecret,
            successUrl: this.props.paymentSaveDestination === 'secondary' ? this.props.secondaryPaymentSuccessUrl : this.props.defaultPaymentSuccessUrl,
            disclosureElement: null,
            checkboxRequired: false
          }),
          React.createElement(
            'p',
            { className: 'u-fontStyleItalic u-tcGrayDark u-mb0x u-mt2x' },
            this.disclaimerText(this.props.paymentIntentAmount, this.props.paymentSaveDestination)
          )
        )
      );
    },

    handleError: function (error) {
      // TODO: replace this w/ notifyError from checkout/payment_form/payment_form_helper/notifier.ts
      Kale.notify({
        collectionName: 'premium',
        eventData: {
          event: 'update_credit_card_error',
          href: window.location.href,
          error_type: error && 'type' in error ? error.type : undefined,
          error_code: error && 'code' in error ? error.code : undefined,
          error_decline_code: error && 'decline_code' in error ? error.decline_code : undefined,
          error_message: error && 'message' in error ? error.message : undefined,
          error_object: error
        }
      });
    }
  });
})();


(function () {

  Aedu.AnalyticsDashboard.GlobalImpactContainer = createReactClass({
    getStateFromStore: function () {
      return {
        countries: Aedu.ReduxStore.getState().AnalyticsDashboard.Countries,
        displayedDates: Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates
      };
    },

    getInitialState: function () {
      return this.getStateFromStore();
    },

    componentDidMount: function () {
      this.unsubscribe = Aedu.ReduxStore.subscribe((function () {
        this.setState(this.getStateFromStore());
      }).bind(this));

      Aedu.ReduxStore.dispatch(Aedu.ActionCreators.AnalyticsDashboard.Countries.fetch());
    },

    componentWillUnmount: function () {
      this.unsubscribe();
    },

    renderCountryRows: function () {
      return _.chain(this.state.countries).sortBy("thirtyDayViews").first(7).map(function (country) {
        return React.createElement(
          "tr",
          { key: country.countryCode },
          React.createElement(
            "td",
            null,
            iso.countries[country.countryCode].name
          ),
          React.createElement(
            "td",
            null,
            country.thirtyDayViews
          )
        );
      }).value();
    },

    render: function () {
      var cellClasses = "u-fs11 u-borderBottom0 u-ph4x u-pv1x u-tcGrayDarker u-fw500";
      if (this.state.countries.models.length) {
        return React.createElement(
          "div",
          { className: "panel panel-flat a-fadeInDown" },
          React.createElement(
            "div",
            { className: "panel-heading" },
            React.createElement(
              "h4",
              { className: "u-fw300 u-tcGrayDarker" },
              "Your Global Impact"
            )
          ),
          React.createElement(
            "div",
            { className: "container-fluid" },
            React.createElement(
              "div",
              { className: "row" },
              React.createElement(
                "div",
                { className: "col-xs-8 panel-vertical-split u-pv4x" },
                React.createElement(Aedu.AnalyticsDashboard.CountriesMap, {
                  countries: this.state.countries.models,
                  countAttribute: "thirtyDayViews",
                  dayCount: this.state.displayedDates.dayCount
                })
              ),
              React.createElement(
                "div",
                { className: "col-xs-4 panel-vertical-split u-p0x" },
                React.createElement(Aedu.AnalyticsDashboard.GlobalImpactCountriesTable, {
                  countries: this.state.countries.models,
                  dayCount: this.state.displayedDates.dayCount
                })
              )
            )
          )
        );
      } else if (this.state.countries.meta.fetching) {
        return React.createElement(
          "div",
          { className: "u-taCenter u-pv4x" },
          React.createElement("i", { className: "fa fa-spin fa-spinner u-fs36" })
        );
      } else {
        return React.createElement("div", null);
      }
    }
  });
})();
(function () {

  Aedu.AnalyticsDashboard.GlobalImpactCountriesTable = createReactClass({
    propTypes: {
      countries: PropTypes.array.isRequired,
      dayCount: PropTypes.number.isRequired
    },

    renderCountryRows: function () {
      var cellClasses = "u-ph4x u-pv5x u-tcGrayDarker";
      return _.chain(this.props.countries).sortBy("thirtyDayViews").reverse().first(7).map(function (country) {
        var isoCountry = iso.countries[(country.countryCode || "").toUpperCase()];
        return React.createElement(
          "tr",
          { key: country.countryCode, className: "u-fs12" },
          React.createElement(
            "td",
            { className: cellClasses + " u-textTruncate" },
            isoCountry ? isoCountry.name : "Unknown"
          ),
          React.createElement(
            "td",
            { className: cellClasses + " u-textAlignCenter" },
            country.thirtyDayViews
          )
        );
      }).value();
    },

    render: function () {
      var cellClasses = "u-fs11 u-borderBottom0 u-ph4x u-pv1x u-tcGrayDarker u-fw500";
      return React.createElement(
        "table",
        { className: "table u-mb0x" },
        React.createElement(
          "thead",
          null,
          React.createElement(
            "tr",
            { className: "u-bgColorGrayLightest" },
            React.createElement(
              "th",
              { className: cellClasses },
              "Countries"
            ),
            React.createElement(
              "th",
              { className: cellClasses + " u-taCenter", style: { width: "100px" } },
              this.props.dayCount + " Day",
              " Views"
            )
          )
        ),
        React.createElement(
          "tbody",
          null,
          this.renderCountryRows()
        )
      );
    }
  });
})();
(function () {
  var CHART_COLORS = {
    DOC_VIEWS_ORANGE: "#e86830",
    PROFILE_VIEWS_YELLOW: "#e8b730",
    DOWNLOADS_GREEN: "#92AA4A",
    TOTAL_VIEWS_PURPLE: "#9f6aa9"
  };

  var getChartConfig = function (startDate) {
    var pointStart = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()).valueOf();

    return {
      defaultChartConfig: {
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          tickInterval: 24 * 3600 * 1000,
          tickWidth: 0,
          dateTimeLabelFormats: {
            month: '%b %e',
            day: '%b %e'
          },
          labels: {
            step: 4,
            staggerLines: 1
          }
        },
        yAxis: {
          title: false,
          min: 0,
          allowDecimals: false,
          gridLineColor: '#E9E9E9'
        },
        legend: {
          enabled: false
        },
        title: {
          text: undefined
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          backgroundColor: "white",
          borderColor: "#dddddd"
        },
        plotOptions: {
          series: {
            groupPadding: .05
          },
          column: {
            stacking: 'normal',
            borderWidth: 0
          }
        }
      },
      defaultSeriesConfig: {
        pointStart: pointStart,
        pointInterval: 24 * 3600 * 1000,
        shadow: false,
        marker: {
          symbol: 'circle',
          radius: 4,
          fillColor: '#FFFFFF',
          lineColor: null,
          lineWidth: 2
        }
      }
    };
  };

  Aedu.AnalyticsDashboard.PremiumOverviewTabChart = createReactClass({
    propTypes: {
      hits: PropTypes.object.isRequired,
      previousDateRangeHits: PropTypes.object.isRequired,
      downloads: PropTypes.object.isRequired,
      startDate: PropTypes.object.isRequired,
      finishDate: PropTypes.object.isRequired,
      dayCount: PropTypes.number.isRequired
    },

    initializeLineGraph: function (el) {
      if (!el) return;

      var config = getChartConfig(this.props.startDate);
      var groupedWorkHits = _.groupBy(_.filter(this.props.hits.models, function (hit) {
        return hit && hit.page && hit.page.work_id;
      }), function (hit) {
        return moment(hit.epoch).format('YYYY-MM-DD');
      });

      var groupedProfileHits = _.groupBy(_.filter(this.props.hits.models, function (hit) {
        return !(hit && hit.page && hit.page.work_id);
      }), function (hit) {
        return moment(hit.epoch).format('YYYY-MM-DD');
      });

      var groupedDownloads = _.groupBy(this.props.downloads.models, function (download) {
        return moment(download.epoch).format('YYYY-MM-DD');
      });

      var series = _.map([Analytics.Utilities.transformToDayCounts(groupedDownloads), Analytics.Utilities.transformToDayCounts(groupedProfileHits), Analytics.Utilities.transformToDayCounts(groupedWorkHits)], function (singleSeries, index) {
        return _.extend({
          name: ['Downloads', 'Profile Views', 'Document Views'][index],
          data: singleSeries,
          color: [CHART_COLORS.DOWNLOADS_GREEN, CHART_COLORS.PROFILE_VIEWS_YELLOW, CHART_COLORS.DOC_VIEWS_ORANGE][index]
        }, config.defaultSeriesConfig);
      });
      var customChartConfig = {
        chart: {
          type: 'column',
          renderTo: el
        },
        series: series
      };
      var chartConfig = _.extend(customChartConfig, config.defaultChartConfig);

      new Highcharts.Chart(chartConfig);
    },

    initializeDeltaTooltip: function (title) {
      return function (el) {
        if (!el) return;

        $(el).tooltip({
          title: title
        });
      };
    },

    renderBox: function (options) {
      var delta = (options.count - options.previousDateRangeCount) / options.previousDateRangeCount;
      var deltaTextClasses = classNames("u-fs14", {
        "u-tcGreen": delta > 0,
        "u-tcRed": delta < 0,
        "u-displayNone": delta === 0 || !_.isFinite(delta)
      });
      var deltaIconClasses = classNames("fa", {
        "fa-caret-up": delta > 0,
        "fa-caret-down": delta < 0
      });
      var circleClasses = classNames("u-mr2x", {
        "u-displayNone": !options.color,
        "u-displayInlineBlock": options.color
      });
      return React.createElement(
        "div",
        { className: "col-xs-3 panel-vertical-split u-p0x" },
        React.createElement(
          "div",
          { className: "u-p6x u-tcGrayDarker" },
          React.createElement("div", { className: circleClasses, style: { height: 12, width: 12, background: options.color, borderRadius: "50%" } }),
          options.label,
          React.createElement("br", null),
          React.createElement(
            "h5",
            { className: "u-fw700 u-fs22 u-mb0x" },
            $h.commaizeInt(options.count),
            "   ",
            React.createElement(
              "span",
              { className: deltaTextClasses, ref: this.initializeDeltaTooltip("Change since previous " + this.props.dayCount + "-day period") },
              React.createElement("i", { className: deltaIconClasses }),
              " ",
              Math.abs(Math.round(delta * 100)),
              "%"
            )
          )
        )
      );
    },

    render: function () {
      if (this.props.hits.meta.fetching || this.props.downloads.meta.fetching) {
        return React.createElement(
          "div",
          { className: "u-taCenter u-pv4x" },
          React.createElement("i", { className: "fa fa-spin fa-spinner u-fs36" })
        );
      }
      return React.createElement(
        "div",
        { className: "panel panel-flat a-fadeInDown" },
        React.createElement(
          "div",
          { className: "panel-body" },
          React.createElement("div", { ref: this.initializeLineGraph, key: "h-" + this.props.hits.models.length + "d-" + this.props.downloads.models.length })
        ),
        React.createElement("div", { className: "panel-horizontal-split" }),
        React.createElement(
          "div",
          { className: "row u-m0x" },
          this.renderBox({
            count: _.filter(this.props.hits.models, function (hit) {
              return hit.page.work_id;
            }).length,
            previousDateRangeCount: _.filter(this.props.previousDateRangeHits.models, function (hit) {
              return hit.page.work_id;
            }).length,
            label: this.props.dayCount + "-day Document Views",
            color: CHART_COLORS.DOC_VIEWS_ORANGE
          }),
          this.renderBox({
            count: _.filter(this.props.hits.models, function (hit) {
              return !hit.page.work_id;
            }).length,
            previousDateRangeCount: _.filter(this.props.previousDateRangeHits.models, function (hit) {
              return !hit.page.work_id;
            }).length,
            label: this.props.dayCount + "-day Profile Views",
            color: CHART_COLORS.PROFILE_VIEWS_YELLOW
          }),
          this.renderBox({
            count: this.props.downloads.models.length,
            previousDateRangeCount: this.props.previousDateRangeDownloads.models.length,
            label: this.props.dayCount + "-day Downloads",
            color: CHART_COLORS.DOWNLOADS_GREEN
          }),
          this.renderBox({
            count: _.map(_.groupBy(this.props.hits.models, function (hit) {
              return hit.visitor.id;
            }), function (i) {
              return i;
            }).length,
            previousDateRangeCount: _.map(_.groupBy(this.props.previousDateRangeHits.models, function (hit) {
              return hit.visitor.id;
            }), function (i) {
              return i;
            }).length,
            label: this.props.dayCount + "-day Unique Visitors"
          })
        )
      );
    }
  });
})();
/*This key is here to force the graph to rerender whenever the data that it relies on changes */;
(function () {

  Aedu.AnalyticsDashboard.PremiumOverviewTabChartContainer = createReactClass({
    getStateFromStore: function () {
      return {
        hits: Aedu.ReduxStore.getState().AnalyticsDashboard.Hits,
        previousDateRangeHits: Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeHits,
        downloads: Aedu.ReduxStore.getState().AnalyticsDashboard.Downloads,
        previousDateRangeDownloads: Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeDownloads,
        displayedDates: Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates
      };
    },

    getInitialState: function () {
      return this.getStateFromStore();
    },

    componentDidMount: function () {
      this.unsubscribe = Aedu.ReduxStore.subscribe((function () {
        this.setState(this.getStateFromStore());
      }).bind(this));

      Aedu.ReduxStore.dispatch(Aedu.ActionCreators.AnalyticsDashboard.Hits.fetch());
      Aedu.ReduxStore.dispatch(Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeHits.fetch());
      Aedu.ReduxStore.dispatch(Aedu.ActionCreators.AnalyticsDashboard.Downloads.fetch());
      Aedu.ReduxStore.dispatch(Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeDownloads.fetch());
    },

    componentWillUnmount: function () {
      this.unsubscribe();
    },

    render: function () {
      return React.createElement(Aedu.AnalyticsDashboard.PremiumOverviewTabChart, {
        hits: this.state.hits,
        previousDateRangeHits: this.state.previousDateRangeHits,
        downloads: this.state.downloads,
        previousDateRangeDownloads: this.state.previousDateRangeDownloads,
        startDate: this.state.displayedDates.start,
        finishDate: this.state.displayedDates.finish,
        dayCount: this.state.displayedDates.dayCount
      });
    }
  });
})();






